<template>
  <b-container>
    <b-row class="mt-4">
      <b-btn v-b-modal.add-question variant="success">Add Question</b-btn>
    </b-row>
    <b-row>
      <b-table responsive striped hover :items="getQuestionnaire" :fields="fields">
        <template v-slot:cell(#)="data">{{data.index + 1}}</template>
        <template v-slot:cell(module)="data">{{data.item.module}}</template>
        <template v-slot:cell(language)="data">{{data.item.language}}</template>
        <template v-slot:cell(type)="data">{{data.item.type}}</template>
        <template v-slot:cell(question)="data">{{data.item.question}}</template>
        <template v-slot:cell(action)="data">
          <b-button size="sm" variant="success" @click="showChoices(data)">Show Choices</b-button>
          <b-button size="sm" variant="info" class="ml-2" @click="editQuestion(data.item)">Edit</b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="primary"
            @click="addQuestionChoice(data.item)"
          >Add Choice</b-button>
          <b-button
            size="sm"
            class="ml-2"
            variant="danger"
            @click="deleteQuestion(data.item)"
          >Delete</b-button>
        </template>

        <template v-slot:row-details="data">
          <b-table responsive striped hover :items="data.item.choices" :fields="choicesFields">
            <template v-slot:cell(correctChoice)="data">{{data.item.correctChoice ? 'Yes':'No'}}</template>
            <template v-slot:cell(action)="data">
              <b-btn variant="danger" size="sm" @click="deleteChoice(data.item)">Delete</b-btn>
            </template>
          </b-table>
        </template>
      </b-table>
    </b-row>

    <b-modal id="add-question" title="Add New Question" ref="modal" @ok="addOrEditQuestion">
      <div v-if="show">
        <b-form>
          <b-form-group id="input-group-3" label="Module Name:" label-for="input-3">
            <b-form-select v-model="selectedModule">
              <option v-for="(mod, ind ) in getModules" :key="ind" :value="mod">{{ mod.name }}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group id="input-group-3" label="Select Language:" label-for="input-3">
            <b-form-select v-model="selectedLanguage">
              <option v-for="lang in languages" :key="lang.code" :value="lang">{{ lang.name }}</option>
            </b-form-select>
          </b-form-group>
          <b-form-group id="input-group-3" label="Select Question Type:" label-for="input-3">
            <b-form-select v-model="questionType">
              <option
                v-for="(questionType, ind ) in questionTypes"
                :key="ind"
                :value="questionType.name"
              >{{ questionType.name}}</option>
            </b-form-select>
          </b-form-group>

          <b-form-group id="input-group-1" label="Enter question:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="questionText"
              type="text"
              required
              placeholder="Enter Question here..."
            ></b-form-input>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
    <b-modal id="add-choice" title="Add New Choice" ref="chmodal" @ok="addChoice">
      <div v-if="show">
        <b-form>
          <b-form-group id="input-group-1" label="Enter Choice:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="choice"
              type="text"
              required
              placeholder="Enter Choice here..."
            ></b-form-input>
          </b-form-group>
          <b-form-group id="input-group-1" label="Choice Marks:" label-for="input-1">
            <b-form-input
              id="input-1"
              v-model="marks"
              type="text"
              required
              placeholder="Enter Marks here..."
            ></b-form-input>
          </b-form-group>
          <b-form-group label="Correct Choice">
            <b-form-radio v-model="isCorrectChoice" name="correct" value="true">Yes</b-form-radio>
            <b-form-radio v-model="isCorrectChoice" name="correct" value="false">No</b-form-radio>
          </b-form-group>
        </b-form>
      </div>
    </b-modal>
  </b-container>
</template>

<script>
import { db } from "../../db";
import { languages } from "../../utils/constants";
import { uuid } from "vue-uuid";
export default {
  data() {
    return {
      show: true,
      fields: [
        { key: "#", sortable: false },
        { key: "module", sortable: false },
        { key: "language", sortable: false },
        { key: "type", sortable: false },
        { key: "question", sortable: false },
        { key: "action", sortable: false }
      ],
      choicesFields: [
        { key: "choice", sortable: true },
        { key: "marks", sortable: false },
        { key: "correctChoice", sortable: false },
        { key: "action", sortable: false }
      ],

      languages: languages,
      selectedLanguage: null,
      questionType: null,
      questionTypes: [
        { id: 1, name: "Single Choice" },
        { id: 2, name: "Multiple Choice" },
        { id: 3, name: "Yes No" }
      ],
      selectedModule: null,
      questionText: "",
      choices: [],
      choice: "",
      isCorrectChoice: false,
      marks: 0,
      moduleId: "",
      updateOperation: false,
      selectedQuestion: null
    };
  },
  computed: {
    // {
    //   categoryName: "Society Culture",
    //   language: "Farsi",
    //   type: "Multiple",
    //   question: "Some Questions",
    //   choices: [
    //     {
    //       choice: "some choice",
    //       correctChoice: true,
    //       marks: "10"
    //     },
    //     {
    //       choice: "another choice",
    //       correctChoice: false,
    //       marks: "0"
    //     }
    //   ]
    // };
    getModules() {
      return this.$store.getters.getModules;
    },
    getQuestionnaire() {
      return this.$store.getters.getQuestionnaire;
    }
  },
  created() {
    if (this.$store.getters.getQuestionnaire.length == 0) {
      this.setQuestionnaire();
    }
    if (this.$store.getters.getModules.length == 0) {
      this.$store.dispatch("setModules");
    }
  },

  methods: {
    addOrEditQuestion(modalEvt) {
      modalEvt.preventDefault();
      this.handleAddQuestions();
      //console.log(data);
    },
    addChoice(modEvnt) {
      modEvnt.preventDefault();
      this.handleAddChoice();
    },
    addQuestionChoice(data) {
      this.selectedQuestion = data;
      this.$refs.chmodal.show();
    },
    handleAddChoice() {
      if (this.validateQuestionChoice()) {
        let data = {
          uuid: uuid.v1(),
          choice: this.choice,
          marks: this.marks,
          correctChoice: this.isCorrectChoice
        };

        let tempArray = this.selectedQuestion.choices;
        tempArray.push(data);
        db.collection("questionnaire")
          .doc(this.selectedQuestion.id)
          .set({ choices: tempArray }, { merge: true });

        this.setQuestionnaire();
        this.$nextTick(() => {
          this.$refs.chmodal.hide();
        });

        this.resetForms();
      } else {
        this.showAlert();
      }
    },
    showAlert() {
      this.$swal.fire({
        title: "Required Fields",
        text: "Please select all fields before submitting!",
        type: "error",

        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33"
      });
    },
    validateQuestionChoice() {
      if (
        this.selectedQuestion !== null &&
        this.choice !== "" &&
        this.marks !== null
      )
        return true;
      else return false;
    },
    handleAddQuestions() {
      if (this.validateQuestionForm()) {
        let data = {
          module: this.selectedModule.name,
          language: this.selectedLanguage.name,
          type: this.questionType,
          question: this.questionText,
          choices: []
        };

        if (!this.updateOperation) {
          db.collection("questionnaire").add(data);
        } else {
          db.collection("questionnaire")
            .doc(this.selectedQuestion.id)
            .update(data);
        }
        this.setQuestionnaire();
        this.resetForms();
        this.$nextTick(() => {
          this.$refs.modal.hide();
        });
      } else {
        this.showAlert();
      }
    },
    validateQuestionForm() {
      if (
        this.selectedLanguage !== null &&
        this.selectedModule !== null &&
        this.questionType !== null &&
        this.questionText !== ""
      )
        return true;
      else return false;
    },
    editQuestion(data) {
      this.selectedQuestion = data;
      this.updateOperation = true;
      //Populate data
      this.questionText = data.question;
      this.selectedLanguage = this.languages.find(lang => {
        return lang.name == data.language;
      });
      this.selectedModule = this.$store.getters.getModule(data.module);
      this.questionType = this.questionTypes.find(qt => {
        return qt.name == data.type;
      }).name;
      this.$refs.modal.show();
    },

    deleteQuestion(data) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            db.collection("questionnaire")
              .doc(data.id)
              .delete();
            this.setQuestionnaire();
          }
        });
    },
    resetForms() {
      this.selectedModule = null;
      this.selectedLanguage = null;
      this.questionType = null;
      this.questionText = "";
      this.choices = [];
      this.updateOperation = false;
      this.selectedQuestion = null;
      this.choice = "";
      this.isCorrectChoice = false;
      this.marks = 0;
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
    setQuestionnaire() {
      this.$store.dispatch("setQuestionnaire");
    },
    showChoices(data) {
      data.toggleDetails();
      this.selectedQuestion = data.item;
    },
    deleteChoice(data) {
      this.$swal
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        })
        .then(result => {
          if (result.value) {
            let tempArray = this.selectedQuestion.choices.filter(ch => {
              return ch.choice !== data.choice;
            });

            db.collection("questionnaire")
              .doc(this.selectedQuestion.id)
              .set({ choices: tempArray }, { merge: true });

            this.setQuestionnaire();
            this.resetForms();
          }
        });
    }
  }
};
</script>